import Swal from 'sweetalert2';

import { colors } from '@globalStyles';

const defaultOptions = {
  title: '',
  text: '',
  showConfirmButton: true,
  confirmButtonColor: colors.evetro_green,
  showCancelButton: true,
  confirmButtonText: 'OK',
  cancelButtonText: 'Cancel',
  focusCancel: true,
  focusConfirm: false,
  icon: 'warning'
};

/**
 * Fire an alert that requires confirmation or dismissal
 * @param {object} swalOptions - an object of swal options
 * @param {boolean} dangerous - whether the action that fired the alert can be considered a 'dangerous' one.
 * True by default
 */
const confirm = (swalOptions = {}, dangerous = false) =>
  Swal.fire({
    ...defaultOptions,
    ...swalOptions,
    customClass: dangerous ? 'swal2-dangerous' : ''
  });

export default confirm;
